module.exports = __webpack_public_path__ + "img/40326515.37626360.png";